import { validMetricsPayload } from '../functions/src/analytics.mjs';

export const preferenceKey = 'goodgamedaily.metrics-optout.v1';
export const legacyConsentKey = 'goodgamedaily.analytics-consent.v1';
const initialized = new WeakSet();

export function privacySignal(win) {
  return win.navigator?.globalPrivacyControl === true || [win.navigator?.doNotTrack, win.navigator?.msDoNotTrack, win.doNotTrack].some(value => value === '1' || value === 'yes');
}

export function metricsPreference(storage) {
  try {
    const preference = storage.getItem(preferenceKey);
    if (preference === '1') return false;
    if (preference === '0') return true;
    const previous = JSON.parse(storage.getItem(legacyConsentKey) || 'null');
    return previous?.choice !== 'denied';
  } catch { return false; }
}

export function startAnalytics(config, win = window, doc = document) {
  // Remove only the host-only cookies used by the previous optional GA tag.
  try {
    for (const item of doc.cookie.split(';')) {
      const name = item.trim().split('=')[0];
      if (/^ggd_ga(?:_|$)/.test(name)) doc.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
    }
  } catch { /* Cookie restrictions must not interrupt the website. */ }
  if (initialized.has(doc)) return;
  const payload = validMetricsPayload(config) ? { category: config.category, ...(config.gameId ? { gameId: config.gameId } : {}) } : null;
  initialized.add(doc);
  let storage;
  try { storage = win.localStorage; } catch { /* Fail closed when preferences cannot be read. */ }
  let allowed = metricsPreference(storage), sent = false, previousFocus;
  const dialog = doc.querySelector('#privacy-settings');
  const toggle = doc.querySelector('#metrics-allowed');
  const message = doc.querySelector('#metrics-settings-status');
  function countPage() {
    if (!payload || sent || !allowed || privacySignal(win) || doc.visibilityState !== 'visible' || doc.prerendering) return;
    sent = true; // One attempt per document; retries could double-count without an identifier.
    try {
      void win.fetch('/api/metrics', { method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer', keepalive: true, cache: 'no-store', mode: 'same-origin', redirect: 'error', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(() => {});
    } catch { /* Aggregate counts are best effort and never block the page. */ }
  }
  function paint() {
    if (!toggle || !message) return;
    const signal = privacySignal(win);
    toggle.checked = allowed && !signal;
    toggle.disabled = signal;
    message.textContent = signal ? 'Anonymous page counts are off because your browser sends a privacy signal.' : allowed ? 'Anonymous page counts are on. No visitor identifier is created.' : 'Anonymous page counts are off. Your saved privacy choice is respected.';
  }
  if (dialog && toggle && message) {
    for (const node of doc.querySelectorAll('[data-privacy-settings]')) node.addEventListener('click', () => {
      previousFocus = node; paint(); if (!dialog.open) dialog.showModal();
    });
    dialog.addEventListener('close', () => previousFocus?.focus());
    toggle.addEventListener('change', () => {
      allowed = toggle.checked;
      let saved = true;
      try { storage.setItem(preferenceKey, allowed ? '0' : '1'); } catch { saved = false; }
      paint();
      if (!saved) message.textContent = 'This choice applies to this page. Your browser could not save it for future visits.';
      countPage();
    });
  }
  doc.addEventListener('visibilitychange', countPage);
  doc.addEventListener('prerenderingchange', countPage);
  win.addEventListener('storage', event => {
    if (![preferenceKey, legacyConsentKey, null].includes(event.key)) return;
    allowed = metricsPreference(storage); paint(); countPage();
  });
  paint(); countPage();
}
